export default __webpack_public_path__ + "static/media/img_21.dddde9b9.jpg";